import httpClient from '@/http-client'
import { baseMutations, baseState } from '@/store/mixins'

const BASE_URL = '/api/report/daily-closeout'

export default {
  namespaced: true,
  state: {
    ...baseState
  },
  mutations: {
    ...baseMutations
  },
  actions: {
    async fetch(context, attrubutes = {}) {
      let params = Object.assign(
        {
          page: context.state.pagination.page,
          perPage: context.state.pagination.perPage,
        },
        attrubutes
      )
      let response = await httpClient.post(`${BASE_URL}`,
        params
      )
      context.commit('RECEIVE_RESOURCES', response.data)
      return response
    },
    async pdf(context, attrubutes = {}) {
      let data = Object.assign(
        {
          page: context.state.pagination.page,
          perPage: context.state.pagination.perPage,
        },
        attrubutes
      )
      let response = await httpClient.post(`${BASE_URL}/pdf`,
        data
      )
      return response
    },
    async toExcel(context, attrubutes = {}) {
      let data = Object.assign(
        {
          page: context.state.pagination.page,
          perPage: context.state.pagination.perPage,
        },
        attrubutes
      )
      let response = await httpClient.post(`${BASE_URL}/excel`, data, {
        responseType: 'arraybuffer'
      })
      return response
    },
    async getBranch(context) {
      let response = await httpClient.get(`${BASE_URL}/assign-branch`)
      return response
    },    
    async getSubProgram(context) {
      let response = await httpClient.get(`${BASE_URL}/sub-program`)
      return response
    },
  }
}
